import React from 'react';

export default function PrivacyPage() {
  return (
    <div style={{ marginTop: 20 }}>
      <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 12 }}>Privacy Policy</h2>
      <h3 style={{ fontSize: 16, fontWeight: 600, marginTop: 16 }}>Data we process</h3>
      <p style={{ fontSize: 14, lineHeight: '1.6' }}>email, name, billing address (via <a href="https://stripe.com/" target="_blank" rel="noreferrer">Stripe</a>), IP addresses used to access your account, signature timestamp/IP/UA, and download logs (IP, user agent, timestamp, repository, order linkage).</p>
      <h3 style={{ fontSize: 16, fontWeight: 600, marginTop: 16 }}>Purpose</h3>
      <p style={{ fontSize: 14, lineHeight: '1.6' }}>provide access, account security, fraud prevention, and legal compliance.</p>
      <h3 style={{ fontSize: 16, fontWeight: 600, marginTop: 16 }}>Payments</h3>
      <p style={{ fontSize: 14, lineHeight: '1.6' }}>Payments are processed by <a href="https://stripe.com/" target="_blank" rel="noreferrer">Stripe</a>; we do not store full card details.</p>
      <h3 style={{ fontSize: 16, fontWeight: 600, marginTop: 16 }}>Retention</h3>
      <p style={{ fontSize: 14, lineHeight: '1.6' }}>anti-fraud and transactional evidence may be retained as required by applicable law.</p>
      <h3 style={{ fontSize: 16, fontWeight: 600, marginTop: 16 }}>Your rights</h3>
      <p style={{ fontSize: 14, lineHeight: '1.6' }}>You can request data access or deletion by emailing <strong>nelso@barbotine.xyz</strong>. Where law requires retention for legal obligations, we may retain specific records.</p>
    </div>
  );
}


